import { forwardRef } from 'react';

import MuiLink from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import type { SxProps, Theme } from '@mui/material/styles';

interface Props {
  readonly color?: string;
  readonly href?: string | URL | null;
  readonly label?: string;
  readonly sx?: SxProps<Theme>;
}

export const LinkToNewTab = forwardRef<HTMLAnchorElement, Readonly<Props>>(
  function LinkToNewTab({ color = 'secondary', href, label, sx }, ref) {
    const link = href?.toString();

    return link ? (
      <MuiLink
        color={color}
        href={link}
        ref={ref}
        rel="noopener noreferrer"
        sx={sx}
        target="_blank"
      >
        {label ?? link}{' '}
        <OpenInNewIcon fontSize="small" sx={{ verticalAlign: 'middle' }} />
      </MuiLink>
    ) : (
      <>Inconnu</>
    );
  },
);
